"use client";
import { createContext, useContext } from "react";

type ScriptsContextValue = {
  setScript?: () => void;
  loadingRefs?: {
    current: {
      [key: string] : boolean
    }
  };
  scriptData?: {
    [key: string] :{
      url: string;
    }
  }
};

export const ScriptsContext = createContext<ScriptsContextValue>({
  setScript: () => null,
  loadingRefs: { current: {}}
});

export const useScriptsContext = () => useContext(ScriptsContext);
